import ServerTimeService from '@/services/ServerTimeService';
import { cleanDoc } from './formatters';

const KEY = 'aXrm7e8VWjXkWTHcdFh2zJsvVeE88Ey2';

function encrypt(plainString: string, key: string) {
  let cypher = '';

  for (let i = 0; i < plainString.length; i += 1) {
    // eslint-disable-next-line no-bitwise
    const dec = plainString.charCodeAt(i) ^ key.charCodeAt(i % key.length);
    const hex = dec.toString(16).padStart(2, '0');
    cypher += hex;
  }

  return cypher;
}

function randomString(length: number) {
  const validChars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghijklmnopqrstuvwxyz';
  let result = '';

  for (let i = 0; i < length; i += 1) {
    result += validChars.charAt(Math.floor(Math.random() * validChars.length));
  }

  return result;
}

export default function generateToken(document: string) {
  const now = ServerTimeService.syncedTime.getTime().toString();

  const innerKey = randomString(8);
  const tokenData = {
    a: window.btoa(innerKey),
    b: window.btoa(encrypt(now, innerKey)),
    c: window.btoa(randomString(32)),
    d: window.btoa(encrypt(cleanDoc(document), innerKey)),
  };

  return encrypt(JSON.stringify(tokenData), KEY);
}
